/**
 * Fehlerprotokoll dieses Geraets – fuer die Diagnose im Admin-Bereich.
 *
 * Haelt die letzten 50 unbehandelten Fehler im localStorage fest (Zeit,
 * Meldung, Ort). Verlaesst das Geraet nie: kein Versand an einen Server.
 * Wer es teilen will, kopiert es im Admin-Bereich selbst.
 */

const KEY = 'sr:error-log';
const MAX = 50;

export interface LoggedError {
  at: number;
  message: string;
  source: string;
}

export function readErrors(): LoggedError[] {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as LoggedError[]) : [];
  } catch {
    return [];
  }
}

export function clearErrors(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* egal */
  }
}

export function logError(message: string, source = ''): void {
  try {
    const list = readErrors();
    list.push({ at: Date.now(), message: message.slice(0, 500), source: source.slice(0, 200) });
    localStorage.setItem(KEY, JSON.stringify(list.slice(-MAX)));
  } catch {
    /* Speicher voll oder gesperrt: dann eben nicht */
  }
}

/** Einmal beim Start: unbehandelte Fehler mitschreiben. */
export function installErrorLog(): void {
  window.addEventListener('error', (ev) => {
    const where = ev.filename ? `${ev.filename.split('/').pop()}:${ev.lineno}` : '';
    logError(ev.message || String(ev.error), where);
  });
  window.addEventListener('unhandledrejection', (ev) => {
    const reason = ev.reason as { message?: string; code?: string } | undefined;
    logError(reason?.message ?? reason?.code ?? String(ev.reason), 'Promise');
  });
}
